import { useSrpFiltersInitialized } from 'lib/hooks/useSrpFilters';
import { InitialSrpParams } from 'lib/hooks/useSrpModel';

export interface UseShouldSrpLoadProps {
  initialParams?: Partial<InitialSrpParams>;
}

export default function useShouldSrpLoad({ initialParams }: UseShouldSrpLoadProps): boolean {
  // this hook provides a place to specify conditional SRP reloading behavior

  const isInitialized = useSrpFiltersInitialized();

  return (
    isInitialized && initialParams?.latitude !== undefined && initialParams?.longitude !== undefined
  );
}
